import React from "react"
import {graphql, Link} from "gatsby"
import Layout from "../components/layout";
import Back from "../assets/svg/back.inline.svg"
import Document from "../assets/svg/pdf.inline.svg"
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import queryString from "query-string";

export default function Template({data, location}) {
    const urlParams = queryString.parse(location.search);
    const urlCat = urlParams.urlCat ?? ''

    const {markdownRemark, allMarkdownRemark} = data
    const {frontmatter} = markdownRemark
    const dataPages = allMarkdownRemark.edges;
    const param = urlCat ? '?urlCat=' + urlCat : ''


    return (
        <Layout fullHeader={false}>
            <div className="blog-post-container">
                <div className="top">
                    <p><Link to={'/' + param + "#filter"}><Back/>Regresar a Videos</Link></p>
                    <p><Link to={'/'}><Back/>Regresar al Inicio</Link></p>
                </div>
                <div className="blog-post">

                    <div className="left">
                        <iframe title={frontmatter.title} src={`https://player.vimeo.com/video/${frontmatter.video}&autoplay=1&loop=1&autopause=0`} width="640"
                        height="360" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen/>
                        {/*<p>{frontmatter.date}</p>*/}
                        <p>{frontmatter.cat}</p>
                        <p className={'quote'}>{frontmatter.quote}</p>
                    </div>
                    <div className="right">
                        <h1 dangerouslySetInnerHTML={{__html: frontmatter.title}}></h1>
                        <div className="content" dangerouslySetInnerHTML={{__html: frontmatter.content}}/>
                        <a download href={frontmatter.file.publicURL}>
                            <Document/> Descargar Cuadernillo</a><br/>
                        <a download href={frontmatter.file_es.publicURL}>
                            <Document/> Descargar Cuadernillo en Español</a>
                    </div>
                </div>
            </div>

            <div className="related">
                <h4>Ver También</h4>
                <div className="grid">
                    {dataPages.map(dataPage => {
                        let title = dataPage.node.frontmatter.title.toLowerCase()
                        return (
                            <div key={title} className={'item'}>
                                <div className="img">
                                    <GatsbyImage image={getImage(dataPage.node.frontmatter.thumbnail)}
                                                 alt={title}/>
                                </div>
                                <h3 dangerouslySetInnerHTML={{__html: dataPage.node.frontmatter.title}}></h3>
                                {/*<p>{dataPage.node.frontmatter.date}</p>*/}
                                <p>{dataPage.node.frontmatter.cat}</p>
                                <Link to={'/' + dataPage.node.frontmatter.slug + '.html' + param}>Ver más</Link>
                            </div>
                        )
                    })}
                </div>
            </div>

        </Layout>
    )
}
export const pageQuery = graphql`
  query($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        slug
        cat
        title
        date(formatString: "MMMM DD, YYYY", locale: "es")
        content
        quote
        video
        file_es {
          publicURL
        }
        file {
          publicURL
        }
      }
    }
    allMarkdownRemark(limit: 4) {
      edges {
        node {
          frontmatter {
            title
            slug
            cat
            date  
            thumbnail {
              childImageSharp {             
                gatsbyImageData(
                  width: 365
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }  
          }
        }
      }
    }
  }
`
